import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Satellite } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface AppShellProps {
  children: React.ReactNode;
}

interface NavLink {
  to: string;
  label: string;
}

const NAV_LINKS: NavLink[] = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/messages', label: 'Messages' },
  { to: '/apps', label: 'Apps' },
  { to: '/settings', label: 'Settings' },
];

const AppShell: React.FC<AppShellProps> = ({ children }) => {
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  const links: NavLink[] = isAdmin
    ? [...NAV_LINKS, { to: '/admin', label: 'Admin' }]
    : NAV_LINKS;

  return (
    <div className="bg-gray-50 min-h-screen">
      <header className="bg-white border-b border-gray-200 print:hidden">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Satellite className="w-6 h-6 text-gray-900 mr-2" />
              <span className="text-lg font-semibold text-gray-900">AI Sat SMS</span>
              <nav className="ml-8 flex space-x-6">
                {links.map(link => {
                  const active = location.pathname === link.to;
                  return (
                    <Link
                      key={link.to}
                      to={link.to}
                      className={
                        active
                          ? 'flex items-center h-16 text-sm font-medium text-gray-900 border-b-2 border-gray-900'
                          : 'flex items-center h-16 text-sm font-medium text-gray-500 border-b-2 border-transparent'
                      }
                    >
                      {link.label}
                    </Link>
                  );
                })}
              </nav>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">{user?.email}</span>
              <button
                onClick={logout}
                className="text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-8">{children}</main>
    </div>
  );
};

export default AppShell;
